import { render, staticRenderFns } from "./OrderBoxProductsCommentsPopup.vue?vue&type=template&id=5adb7b89&scoped=true&"
import script from "./OrderBoxProductsCommentsPopup.vue?vue&type=script&lang=js&"
export * from "./OrderBoxProductsCommentsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb7b89",
  null
  
)

export default component.exports